<header id="page-topbar" [ngClass]="locale==Locales.BN_BN? 'font-bn-nav':'font-en'">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/dash/dashboard" class="logo logo-dark">
          <span class="logo-sm">
              <img src="{{logoUrl(false)}}" alt="" height="36">
          </span>
          <span class="logo-lg">
              <img src="{{logoUrl(true)}}" alt="" height="72" width="72">
          </span>
        </a>

        <a routerLink="/dash" class="logo logo-light">
          <span class="logo-sm">
              <img src="{{logoUrl(false)}}" alt="" height="36">
          </span>
          <span class="logo-lg">
              <img src="{{logoUrl(true)}}" alt="" height="72">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn"
              (click)="initLeftMenuCollapse()">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- App Search-->
      <form class="app-search d-none d-lg-block" (submit)="onSearch()">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="{{translations['Search..']}}" [formControl]="search">
          <span class="bx bx-search-alt" *ngIf="!search.value"></span>
          <a *ngIf="search.value" href="javascript: void(0);" (click)="clearSearch()">
            <span class="bx bx-x-circle text-danger"></span>
          </a>
        </div>
      </form>


      <div class="btn-group">
        <button type="button" class="btn header-item waves-effect"
                data-bs-toggle="dropdown" aria-expanded="false">
          {{ selectedOrg? selectedOrg.name: 'Select Organization' }}
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <div class="dropdown-menu">
          <a class="dropdown-item py-3 d-flex align-items-center justify-content-start" href="javascript:void(0);" *ngFor="let org of orgs" (click)="onOrgSelected(org)">
            <i class="bx bx-buildings me-2"></i> <h6 class="d-inline mb-0">{{ org.name }}</h6>
          </a>
        </div>
      </div>


      <!--      <div class="dropdown dropdown-mega d-none d-lg-block ms-2">-->
      <!--        <button type="button" class="btn header-item waves-effect" data-bs-toggle="dropdown" aria-haspopup="false"-->
      <!--                aria-expanded="false">-->
      <!--          <span key="t-megamenu">Apps</span>-->
      <!--          <i class="mdi mdi-chevron-down"></i>-->
      <!--        </button>-->
      <!--        <div class="dropdown-menu dropdown-megamenu">-->
      <!--          <div class="row">-->
      <!--            <div class="col-sm-8">-->

      <!--              <div class="row">-->
      <!--                <div class="col-md-4">-->
      <!--                  <h5 class="font-size-14" key="t-ui-components" *ngIf="hasPrivilege('CAN_TAKE_EXAM')">PollBox</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-lightbox"-->
      <!--                         routerLink="/dash/questionnaires">Questionnaires</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-range-slider" routerLink="/dash/polls">Polls</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-sweet-alert" routerLink="/dash/poll-options"-->
      <!--                         *ngIf="isAdmin">Poll Options</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-rating" *ngIf="isAdmin" routerLink="/dash/votes">Votes</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->

      <!--                <div class="col-md-4" *ngIf="isAdmin">-->
      <!--                  <h5 class="font-size-14" key="t-applications">Inventory</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/categories">Categories</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/brands">Brands</a>-->
      <!--                    </li>-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-ecommerce" routerLink="/dash/inventory/filterable-attributes">Filterable Attributes</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->

      <!--                <div class="col-md-4">-->
      <!--                  <h5 class="font-size-14" key="t-extra-pages">CMS</h5>-->
      <!--                  <ul class="list-unstyled megamenu-list">-->
      <!--                    <li>-->
      <!--                      <a href="javascript:void(0);" key="t-light-sidebar" routerLink="/cms/files">File Manager</a>-->
      <!--                    </li>-->
      <!--                  </ul>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->

      <!--          </div>-->

      <!--        </div>-->
      <!--      </div>-->
    </div>

    <div class="d-flex">
      <div class="btn-group">
        <button type="button" class="btn btn-soft-light dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="mdi mdi-plus-circle-outline text-success font-size-24"></i>
        </button>
        <div class="dropdown-menu">
          <div class="dropdown-header noti-title">
            <h5 class="font-size-13 text-muted text-truncate mn-0">Create Items!</h5>
          </div>
          <!-- item-->
          <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/dash/inventory/stocks']">Add Stock</a>
          <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/dash/sales/orders/create']">Sell Products</a>
          <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/dash/inventory/products/create']">Add Product</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/dash/web/articles/create']">Create Article</a>
        </div>
      </div>
      <!--      <div class="dropdown d-inline-block" *ngIf="Utility.isTabletOrMobileScreen">-->
<!--      <div class="dropdown d-inline-block">-->
<!--        <button type="button" class="btn header-item waves-effect bg-info me-1"-->
<!--                [routerLink]="['/dash/inventory/stocks']"-->
<!--                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          <i class="mdi mdi-plus-circle-outline text-white font-size-24"></i>-->
<!--        </button>-->
<!--        <button type="button" class="btn header-item waves-effect bg-success"-->
<!--                [routerLink]="['/dash/sales/orders/create']"-->
<!--                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          <i class="mdi mdi-cart-arrow-down text-white font-size-24"></i>-->
<!--        </button>-->
<!--      </div>-->
      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item waves-effect"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img *ngIf="currentLocale===Locals.EN" id="header-lang-img" src="assets/apanel/images/flags/us.jpg"
               alt="Header Language" height="16">
          <img *ngIf="currentLocale===Locals.BN_BN" src="assets/apanel/images/flags/bn.png" alt="user-image"
               class="me-1" height="12">
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="en"
             (click)="setLocale(Locals.EN)">
            <img src="assets/apanel/images/flags/us.jpg" alt="user-image" class="me-1" height="12">
            <span class="align-middle">English</span>
          </a>
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="sp"
             (click)="setLocale(Locals.BN_BN)">
            <img src="assets/apanel/images/flags/bn.png" alt="user-image" class="me-1" height="12">
            <span class="align-middle">বাংলা</span>
          </a>
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button *ngIf="currentTheme===Theme.LIGHT" type="button" class="btn header-item noti-icon waves-effect"
                 (click)="onMenuThemeSelected(Theme.DARK)">
          <i class="bx bx-sun"></i>
        </button>
        <button *ngIf="currentTheme===Theme.DARK" type="button" class="btn header-item noti-icon waves-effect"
                 (click)="onMenuThemeSelected(Theme.LIGHT)">
          <i class="bx bx-moon"></i>
        </button>
      </div>
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="toggleFullScreen($event)">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" *ngIf="!Utility.isTabletOrMobileScreen">
        <button type="button" class="btn header-item waves-effect"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="mdi mdi-grid font-size-18"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="en"
             (click)="onMenuTypeSelected(MenuTypes.VERTICAL)">
            <i class="bx bx-dots-vertical"></i> &nbsp;
            <span class="align-middle">Left Sidebar</span>
          </a>
          <!-- item-->
          <a href="javascript:void(0);"
             class="dropdown-item notify-item language" data-lang="sp"
             (click)="onMenuTypeSelected(MenuTypes.HORIZONTAL)">
            <i class="bx bx-dots-horizontal"></i> &nbsp;
            <span class="align-middle">Top Menu</span>
          </a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img class="rounded-circle header-profile-user" src="https://avatar.iran.liara.run/public"
               alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1" key="t-henry">{{ auth.preferred_username }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <!-- item-->
          <a class="dropdown-item" href="javascript:void(0);" (click)="changePassword()"><i
            class="bx bx-user font-size-16 align-middle me-1"></i> <span
            key="t-profile" i18n="@@label.ChangePassword">Change Password</span></a>
<!--          <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/u/' + auth.username]"><i-->
<!--            class="bx bx-user font-size-16 align-middle me-1"></i> <span-->
<!--            key="t-profile" i18n="@@label.Profile">Profile</span></a>-->
<!--          <a class="dropdown-item" href="javascript:void(0);" (click)="openLeaderboard()"><i-->
<!--            class="bx bx-wallet font-size-16 align-middle me-1"></i> <span-->
<!--            key="t-my-wallet" i18n="@@label.Leaderboard">Leaderboard</span></a>-->
          <!--          <a class="dropdown-item d-block" href="#"><span class="badge bg-success float-end">11</span><i-->
          <!--            class="bx bx-wrench font-size-16 align-middle me-1"></i> <span key="t-settings">Settings</span></a>-->
          <!--          <a class="dropdown-item" href="#"><i class="bx bx-lock-open font-size-16 align-middle me-1"></i> <span-->
          <!--            key="t-lock-screen">Lock screen</span></a>-->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript:void(0)" (click)="logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            <span key="t-logout" i18n="@@label.Logout">Logout</span>
          </a>
        </div>
      </div>

      <!--      <div class="dropdown d-inline-block">-->
      <!--        <button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect" (click)="initRightSidebar()">-->
      <!--          <i class="bx bx-cog bx-spin"></i>-->
      <!--        </button>-->
      <!--      </div>-->

    </div>
  </div>
</header>
